import { LD_ITEMS, LD_DIMS } from "./questionBank.js";
import { scoreLD, LD_NORMS, LD_BANDS, LD_DIM_BANDS, LD_INTERACTIONS } from "./scoring.js";
export { LD_DIMS, LD_NORMS, LD_BANDS, LD_DIM_BANDS, LD_INTERACTIONS };

const LeadershipDerailers = {
  id:"ld", name:"Leadership Derailers Assessment", shortName:"Derailers",
  icon:"⚡", color:"#991b1b", bg:"#fef2f2",
  description:"40-item diagnostic measuring subclinical 'dark side' tendencies that emerge under pressure and can derail otherwise capable leaders. Grounded in Horney's (1950) neurotic trends, Hogan & Hogan's (2001) subclinical derailer research, and Kaiser & Hogan's (2011) curvilinear leadership model. Measures Volatile, Skeptical, Cautious, Detached, Arrogant, Impulsive, Dramatic and Perfectionistic tendencies — each interpreted on a curvilinear scale where moderate levels are often functional and only elevated levels predict derailment.",
  desc:"40 items · 12 minutes · Curvilinear risk bands · Derailer interaction analysis",
  publisher:"AXIS360 Enterprise", version:"1.0",
  itemCount:40, items:40, timeLimit:12, time:"12 min", timeEstimate:"12 minutes",
  format:"likert_0_4", scaleType:"likert-5", isScreener:false, pricingTier:"enterprise", creditCost:20,
  pagesOf:40, totalPages:1, scaleMin:0, scaleMax:4,
  scale:{ min:0, max:4, labels:["Strongly Disagree","Disagree","Neutral","Agree","Strongly Agree"] },
  scaleLabels:["Strongly Disagree","Disagree","Neutral","Agree","Strongly Agree"],
  predicts:["Leadership derailment risk under sustained pressure","Executive coaching priority areas","Team climate risk from leader behaviour","Succession risk for high-stakes or high-pressure roles"],
  questions: LD_ITEMS,
  dims: LD_DIMS,
  score(answers){ return scoreLD(answers); },
  nineboxAxes:{ x:{label:"Derailment Risk",scaleIds:["ld"]}, y:{label:"Derailment Risk",scaleIds:["ld"]} },
};
export default LeadershipDerailers;
